import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule } from '@angular/forms';
import { PopupExampleComponent } from './popup-example.component';
import { PopupDialogExampleComponent } from './popup-dialog-example.component';



@NgModule({
  declarations: [PopupExampleComponent, PopupDialogExampleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule
  ],
  providers: [ ],
  exports: [PopupExampleComponent, PopupDialogExampleComponent]
})
export class PopupExampleModule {
  customElementComponent: Type<any> = PopupExampleComponent;
}

